import requester from '@/lib/axios';
import { OrderingFrom } from '@/models/Filter';
import JsonApiResponse from '@/models/JsonApiResponse';
import { Nullable } from '@/models/Model';
import { BaseFilters } from '@/models/Service';
import {
  BehaviorAssessment,
  CommentAssessment,
  OccurrenceAssessment,
  StudentAssessment,
  StudentAssessmentTypeEnum,
} from '@/models/StudentAssessment';

export const STUDENT_ASSESSMENT_ORDERING_FIELDS = ['created_at'] as const;

export type StudentAssessmentOrdering = OrderingFrom<
  typeof STUDENT_ASSESSMENT_ORDERING_FIELDS
>;

export type ListStudentAssessments = BaseFilters & {
  studentId?: number;
  scheduledLessonId?: number[];
  klassId?: number[];
  type?: StudentAssessmentTypeEnum[];
  dateRangeAfter?: string;
  dateRangeBefore?: string;
  ordering?: StudentAssessmentOrdering;
};

export const listStudentAssessments = async (
  params: ListStudentAssessments = {},
) => {
  const { data } = await requester().get<JsonApiResponse<StudentAssessment>>(
    'student-assessments/',
    {
      params,
    },
  );

  return data;
};

export const getStudentAssessment = async (studentAssessmentId: number) => {
  const { data } = await requester().get<StudentAssessment>(
    `student-assessments/${studentAssessmentId}/`,
  );

  return data;
};

export type StudentAssessmentBody = {
  klassId?: Nullable<number>;
  pedagogicalSheetId?: number;
  behaviorAssessment?: Partial<BehaviorAssessment>;
  commentAssessment?: Partial<CommentAssessment>;
  occurrenceAssessment?: Partial<OccurrenceAssessment>;
};

export const createStudentAssessment = async (body: StudentAssessmentBody) => {
  const { data } = await requester().post<StudentAssessment>(
    'student-assessments/',
    body,
  );

  return data;
};

type StudentAssessmentRequest = {
  assessmentId: number;
  body: Partial<StudentAssessmentBody>;
};

export const updateStudentAssessment = async ({
  assessmentId,
  body,
}: StudentAssessmentRequest) => {
  const { data } = await requester().patch<StudentAssessment>(
    `student-assessments/${assessmentId}/`,
    body,
  );

  return data;
};

export const deleteStudentAssessment = async (assessmentId: number) => {
  await requester().delete(`student-assessments/${assessmentId}/`);
};
